module.exports = "nb-card .row-card.main-card {\n  padding-bottom: 2rem; }\n\nnb-card .row-card .card-box-body {\n  padding-top: 2rem;\n  padding-bottom: 3rem; }\n\nnb-card .row-card .card-box-body .selected-order {\n    color: #f6a800;\n    font-weight: normal;\n    padding-bottom: 0.3rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/shipment-card/shipment-card.component.scss
// module id = ./src/app/shared/shipment-card/shipment-card.component.scss
// module chunks = main